import React from 'react';

function injectStyle() {
  if (document.getElementById('sk-style')) return;
  const s = document.createElement('style');
  s.id = 'sk-style';
  s.textContent = `
    @keyframes sk-shimmer {
      0% { background-position: -600px 0; }
      100% { background-position: 600px 0; }
    }
    .sk-pulse {
      background: linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 40%, #f1f5f9 100%);
      background-size: 1200px 100%;
      animation: sk-shimmer 1.5s infinite linear;
    }
  `;
  document.head.appendChild(s);
}

export function Skeleton({ width = '100%', height = 14, radius = 6, style: sx = {} }) {
  injectStyle();
  return <div className="sk-pulse" style={{ width, height, borderRadius: radius, ...sx }} />;
}

export function SkeletonTable({ rows = 5, cols = 5 }) {
  injectStyle();
  const colWidths = [120, 100, 90, 80, 70];
  return (
    <div style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>
      <div style={{ background: '#f8fafc', padding: '13px 20px', display: 'flex', gap: 20, borderBottom: '2px solid #f1f5f9' }}>
        {Array.from({ length: cols }).map((_, i) => (
          <div key={i} className="sk-pulse" style={{ width: colWidths[i] || 80, height: 12, borderRadius: 3 }} />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} style={{ padding: '14px 20px', display: 'flex', gap: 16, alignItems: 'center', borderBottom: '1px solid #f8fafc' }}>
          <div className="sk-pulse" style={{ width: 38, height: 38, borderRadius: 10, flexShrink: 0 }} />
          {Array.from({ length: cols - 1 }).map((_, j) => (
            <div key={j} className="sk-pulse" style={{ width: colWidths[j] || 80, height: 13, borderRadius: 4 }} />
          ))}
        </div>
      ))}
    </div>
  );
}

export function SkeletonCard({ lines = 3, style: sx = {} }) {
  injectStyle();
  const widths = ['55%', '80%', '65%', '90%', '70%'];
  return (
    <div style={{ background: '#fff', borderRadius: 16, padding: 24, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', ...sx }}>
      <div className="sk-pulse" style={{ width: '45%', height: 20, borderRadius: 6, marginBottom: 20 }} />
      {Array.from({ length: lines }).map((_, i) => (
        <div key={i} className="sk-pulse" style={{ width: widths[i % widths.length], height: 13, borderRadius: 4, marginBottom: 10 }} />
      ))}
    </div>
  );
}
